import { Subject } from "rxjs";
import { apiBase } from "../api";
import { TradingTickData } from "../config/trading";
import { hub } from "../hub";
import { SignalHub } from "../hubSignal";

export class TradingSignal extends SignalHub {
    private tids: string[] = [];
    private priceEvent = new Subject<TradingTickData>();
    constructor() {
        super();
    }

    getPriceChange() {
        return this.priceEvent.asObservable();
    }
    protected override subscribeToHub() {
        this.connection.on('OnMarkPrice', async (d: TradingTickData) => {
            this.priceEvent.next(d);
        });
    }
    protected override async onEndHubStarted() {
        this.subscribeTickers();
    }
    protected async subscribeTickers() {
        await this.connection.invoke("Subscribe", apiBase.getFetchInput(this.tids));
    }
    subscribe(tids: string[]) {
        this.tids = tids;
        if (this.connection == null)
            this.initHub(`https://${hub.tradingHost}/trdhub`);
        if (this.isHubConnected)
            this.subscribeTickers();
    }
}
